// composables/useCompanyFormData.ts
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useKeepersEmployeeData(companyId?: number) {
    const { data: keepersEmployees, isPending: loadingKeepersEmployees } = useQuery({
        queryKey: ['all-keepers-employees', companyId],
        queryFn: async () => {
            const { data } = await axios.get(
                companyId
                    ? route('v2.company.keepers-employees.get', companyId)
                    : route('v2.companies.all-keepers-employees.get'),
            );
            return data;
        },
        placeholderData: [],
    });

    return {
        keepersEmployees,
        loadingKeepersEmployees,
    };
}
